export const APP_LOAD = 'APP_LOAD';
export const REDIRECT = 'REDIRECT';
export const GOTOPAGE = 'GOTOPAGE';
export const SETTINGS_SAVED = 'SETTINGS_SAVED';
export const SETTINGS_PAGE_UNLOADED = 'SETTINGS_PAGE_UNLOADED';
export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED';
export const HOME_PAGE_UNLOADED = 'HOME_PAGE_UNLOADED';
export const SET_PAGE = 'SET_PAGE';
export const PROFILE_PAGE_LOADED = 'PROFILE_PAGE_LOADED';
export const PROFILE_PAGE_UNLOADED = 'PROFILE_PAGE_UNLOADED';
export const CHANGE_TAB = 'CHANGE_TAB';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const GOTOLOGIN = 'GOTOLOGIN';
export const REGISTER = 'REGISTER';
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED';
export const REGISTER_PAGE_UNLOADED = 'REGISTER_PAGE_UNLOADED';
export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';
export const UPDATE_FIELD_AUTH = 'UPDATE_FIELD_AUTH';
export const PROFILE_FAVORITES_PAGE_UNLOADED = 'PROFILE_FAVORITES_PAGE_UNLOADED';
export const PROFILE_FAVORITES_PAGE_LOADED = 'PROFILE_FAVORITES_PAGE_LOADED';
export const APPLICATION_PAGE_LOADED = 'APPLICATION_PAGE_LOADED';
export const APPLICATION_PAGE_UNLOADED = 'APPLICATION_PAGE_UNLOADED';
export const APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED';
export const SITE_SUBMITTED = 'SITE_SUBMITTED';
export const SITE_UPDATED = 'SITE_UPDATED';
export const TRIPS_LOADED = 'TRIPS_LOADED';
export const TABLE_PAGE_LOADED = 'TABLE_PAGE_LOADED';
export const DATA_LIST_LOADED = 'DATA_LIST_LOADED';
export const TABLE_COLUMNS_LOADED = 'TABLE_COLUMNS_LOADED';
export const DB_INITIALIZED = 'DB_INITIALIZED';
export const DB_INITIALIZATION_ERROR = 'DB_INITIALIZATION_ERROR';
export const ADD_CACHE = "ADD_CACHE";
export const DELETE_CACHE = "DELETE_CACHE";